import React, { useContext } from 'react';
import { AppContext } from '@prisjakt/ui-app-context';

import { Badge } from '../../../components/rating/styles';

type Props = {
  className?: string;
  position: number;
};

export default function PositionInList({ className, position }: Props) {
  const { t } = useContext(AppContext);

  return (
    <Badge className={className}>
      {t('expert', 'toplist.product-position', { pos: position })}
    </Badge>
  );
}
